module.exports = __webpack_public_path__ + "img/guozai_08.b2969d10.jpg";